import React from 'react';

import './ExclusiveName.css';
import { hasExclusiveNeon } from './exclusiveName';

export function splitChatLetters(text: string): string[] {
  if (typeof text !== 'string') return [];
  const Segmenter = (Intl as any).Segmenter;
  return Segmenter ? Array.from(new Segmenter('th', { granularity: 'grapheme' }).segment(text), (part: any) => part.segment) : Array.from(text);
}
export function colorChatText(text: string, colors?: string[], earnedNeon = false) {
  const neon = hasExclusiveNeon(text, colors, earnedNeon);
  const palette = Array.isArray(colors) && colors.length ? colors.map(color => typeof color === 'string' && /^#[0-9a-f]{6}$/i.test(color) ? color : '#ffffff') : ['#ffffff'];
  return splitChatLetters(text).map((letter, index) => <span key={index} className={neon ? 'exclusive-neon-letter' : undefined} style={{ color: palette[index % palette.length], ...(neon ? { animationDelay: `${index * -0.35}s` } : {}) }}>{letter}</span>);
}
